import React from 'react';
import { Icon, Button } from '../../../../components';
import { logIn } from '../../../../utils/operon';
import './style.scss';

const Topbar = () => {
	return (
		<section className="login-page__topbar topbar">
			<a href="https://operon.pl" className="topbar__link">
				<Icon name="logo" className="topbar__logo" color="#006d67" width="129" height="34.25" />
			</a>
			<h1 className="topbar__heading">
				<b>Generator</b> Testów
			</h1>
			<Button className="topbar__button" onClick={logIn}>
				Zaloguj
			</Button>
		</section>
	);
};

export default Topbar;
